import fonts from "../../styles/fonts";
import palette from "../../styles/palette";

export default {
    wrapper: {
        textAlign: "center",
        padding: 20
    } as React.CSSProperties,
    container: {
        display: "inline-block",
        width: "100%",
        maxWidth: 1000
    } as React.CSSProperties,
    toolBar: {
        textAlign: "left",
        marginBottom: 20
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        color: palette.text.primary,
        marginBottom: 10
    } as React.CSSProperties,
    message: {
        fontSize: 20,
        color: palette.text.secondary,
    } as React.CSSProperties,
    button: {
        marginRight: 20,
        marginBottom: 10
    } as React.CSSProperties,
};